import { TranslationDict } from "../types";

export const nlCommon: TranslationDict = {
  areYouSure: "Bent u zeker?",
  cancel: "Annuleren",
  datum: "Datum",
  deleteProject: "Verwijder project",
  error: "Fout",
  filter: "Filter...",
  naam: "Naam",
  noProjectsFound: "Geen projecten gevonden",
  ok: "OK",
  openProject: "Project openen",
  projectDeleteConfirm: "Dit project zal definitief verwijderd worden.",
  projects: "Projecten",
  projectName: "Projectnaam",
  save: "Bewaar",
  saveProject: "Bewaar project",
  sortByDate: "Sorteer op datum",
  voornaam: "Voornaam",
  firma: "Firma",
  straat: "Straat",
  huisnummer: "Huisnummer",
  postcode: "Postcode",
  plaats: "Plaats",
  land: "Land",
  telefoon: "Telefoon",
  btwnr: "BTW-nummer",
  verwijderen: "Verwijderen",
  hernoem: "Hernoemen",
  dupliceren: "Dupliceren",
  wijzigIcon: "Wijzig icoon",
  wijzigNaam: "Wijzig naam",
  wit: "Wit",
  zwart: "Zwart",
};
